var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navbar Icon",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1074 2.29084C13.0654 1.76834 14.2333 2.46167 14.2333 3.55281V16.4471C14.2333 17.5383 13.0653 18.2316 12.1074 17.7091L4.04696 13.3125H2.375C1.23591 13.3125 0.3125 12.3891 0.3125 11.25V8.74999C0.3125 7.6109 1.23591 6.68749 2.375 6.68749H4.04692L12.1074 2.29084ZM12.6083 3.86866L5.06662 7.9823V12.0176L12.6083 16.1313V3.86866ZM1.9375 8.74999C1.9375 8.50836 2.13338 8.31249 2.375 8.31249H3.4375V11.6875H2.375C2.13338 11.6875 1.9375 11.4916 1.9375 11.25V8.74999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6387 5.32573C18.919 5.67613 18.8622 6.18743 18.5118 6.46775L16.4284 8.13442C16.078 8.41474 15.5667 8.35793 15.2864 8.00753C15.0061 7.65713 15.0629 7.14583 15.4133 6.86551L17.4966 5.19884C17.847 4.91852 18.3583 4.97533 18.6387 5.32573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5041 10.0208C15.5041 9.57208 15.8679 9.20831 16.3166 9.20831H18.8583C19.307 9.20831 19.6708 9.57208 19.6708 10.0208C19.6708 10.4695 19.307 10.8333 18.8583 10.8333H16.3166C15.8679 10.8333 15.5041 10.4695 15.5041 10.0208Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4284 12.2822C16.078 12.0019 15.5667 12.0587 15.2864 12.4091C15.0061 12.7595 15.0629 13.2708 15.4133 13.5511L17.4966 15.2178C17.847 15.4981 18.3583 15.4413 18.6387 15.0909C18.919 14.7405 18.8622 14.2292 18.5118 13.9489L16.4284 12.2822Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.bfe7935427c5adb43ad884d1ef455270.svg";
export { ForwardRef as ReactComponent };